import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=b4c8980a&scoped=true"
import script from "./Msg.vue?vue&type=script&lang=js"
export * from "./Msg.vue?vue&type=script&lang=js"
import style0 from "./Msg.vue?vue&type=style&index=0&id=b4c8980a&prod&lang=scss&scoped=true"
import style1 from "./Msg.vue?vue&type=style&index=1&id=b4c8980a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c8980a",
  null
  
)

export default component.exports